import React, { useState, useEffect, lazy, Suspense } from "react";
import { Container, Spinner } from "react-bootstrap";
import axios from "axios";
import { useParams } from "react-router-dom";
import HTMLReactParser from "html-react-parser";
import Footer from "../../../FooterNewChanges/FooterNewChanges";


const LatestBlogs = lazy(() => import("./Blogs"));


const PostPage = ({ logo }) => {
    const { postId } = useParams();
    const [blogPosts, setBlogPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetch the single blog content
        async function fetchSingleBlog() {
            try {
                const response = await axios.get(process.env.REACT_APP_CDN_LINK+"myanglai/jsons/active-blogs.json");
                const blog = response.data.find(blog => blog.id.toString() === postId);
                setBlogPosts(blog ? [blog] : []);
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        }
        fetchSingleBlog();
    }, [postId]);

    return (
        <>
            <div className="blogpage">


                {/* Show spinner if loading */}
                {loading ? (
                    <div className="loading-spinner" style={{ textAlign: "center", marginTop: "7rem" }}>
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                ) : (
                    /* Render the rest of the content after loading */
                    <>
                        <div className="blogcontentsection" fetchpriority="high" />
                        <div id="blogdata">
                            <Container>
                                {blogPosts.map((item, i) => (
                                    <div id="blogpost" key={i}>
                                        {HTMLReactParser(item.content)}
                                    </div>
                                ))}
                            </Container>
                        </div>
                        <div fetchpriority="low">

                        </div>
                        <Suspense fallback={<div />}>
                            <div className="blogstop">
                                <LatestBlogs />
                            </div>
                        </Suspense>

                        <Suspense fallback={<div />}>
                            <div className="blogstop">
                                <Footer />
                            </div>
                        </Suspense>

                    </>
                )}
            </div>
        </>
    );
};

export default PostPage;
